module.exports = __webpack_public_path__ + "static/media/img_11.27c4d265.JPG";